import { useEffect, useState } from "react";

/**
 * @description check outbrain_enable variable from external js file
 */
export function useShouldRenderOutbrain() {
  const [shouldRender, setShouldRender] = useState(false);
  useEffect(() => {
    // - check outbrain_enable variable from external js file
    // window.outbrain_enable = 1; // TODO force open here for testing
    if (window.outbrain_enable === 1) {
      setShouldRender(true);
    }
  }, []);

  return shouldRender;
}
